export default "__VITE_ASSET__CE5ps5qr__"